export const ALL_CHARGES = {
    "Animals": [
        "badger statant",
        "bat displayed",
        "bear passant",
        "bear statant",
        "bear's head couped",
        "bee volant",
        "boar's head couped",
        "buffalo statant regardant",
        "bull passant",
        "bull's head caboshed",
        "cow salient",
        "elephant and castle",
        "giraffe statant",
        "goat passant",
        "goat salient",
        "goose",
        "grasshopper passant",
        "greyhound passant",
        "hare salient",
        "hawk on seax",
        "horse passant",
        "horse rampant",
        "leopard rampant",
        "leopard statant",
        "leopard's face",
        "lion couchant",
        "lion dormant",
        "lion passant",
        "lion rampant regardant",
        "lion rampant",
        "lion salient",
        "lion sejant erect",
        "lion sejant",
        "lion's face",
        "lion's foot erased",
        "lynx statant",
        "rabbit statant",
        "ram statant",
        "ram's head caboshed",
        "reindeer statant",
        "serpent nowed",
        "serpent",
        "serpents entwined",
        "sheep hoisted",
        "stag lodged",
        "stag passant",
        "stag salient",
        "stag's head cabossed",
        "stag's head erased",
        "talbot passant",
        "talbot sejant",
        "talbot statant",
        "tiger passant gardant",
        "two fish paired",
        "wasp displayed",
        "wolf passant",
        "wolf salient",
    ],
    "Art": [
        "altar",
        "bugle",
        "cup",
        "flower ornament",
        "game piece 2",
        "game piece",
        "harp",
        "horn",
        "pelice",
        "six sepaled lotus",
        "Thor's hammer",
        "tripod",
        "trumpet",
        "vase 2",
        "vase",
    ],
    "Astronomy": [
        "sun",
        "crescent",
        "decrescent",
        "estoille",
        "increscent",
        "star within the horns of a crescent",
        "star",
        "sun 1",
    ],
    "Birds": [
        "cock",
        "cormorant",
        "crane in its vigilance",
        "crow",
        "dove volant",
        "dove",
        "eagle displayed",
        "eagle rising",
        "eagle's head couped",
        "eagle's leg erased",
        "eagle's leg",
        "falcon",
        "hawk",
        "heron",
        "imperial eagle displayed",
        "martlet volant",
        "martlet",
        "moorcock",
        "ostrich",
        "owl",
        "pelican in her piety",
        "pelican",
        "popinjay",
        "raven",
        "sparrow hawk",
        "stork with a snake",
        "stork",
        "swan",
    ],
    "Buildings": [
        "castle of three towers",
        "castle of two towers",
        "castle",
        "pagoda",
        "portcullis",
        "tower",
    ],
    "Celtic": [
        "Celtic dragon 1",
        "Celtic dragon 2",
        "Celtic ornament 1",
        "Celtic ornament 3",
        "Celtic ornament 4",
        "Celtic ornament 5",
        "Celtic ornament 18",
        "Celtic seal",
        "Celtic spiral",
        "Celtic symbol",
        "Celtic tree",
        "Celtic wolf",
        "dragonfly",
        "Gallic horse",
        "Gallic ornament 1",
        "Gallic ornament 3",
        "Gallic ornament 4",
        "Gallic ornament 5",
        "Gotland beast 1",
        "Gotland beast 2",
        "green man",
        "knotwork salmon",
        "knotwork snake",
    ],
    "Chasing": [
        "four Celtic symbol chasing",
        "sea-dog mirrored",
        "four eagles chasing",
        "three boar heads chasing",
        "four martlets chasing",
        "three heraldic dolphins chasing",
        "four griffin heads chasing",
        "heraldic dolphins mirrored",
        "salmon mirrored",
        "wolves mirrored",
        "four heraldic dolphins chasing",
        "three hawks on seaxes",
        "three beasts chasing",
        "eagle wings mirrored",
        "three rabbits chasing",
        "three stags chasing",
        "eagle wings mirrored 2",
        "four stags chasing",
        "three antelope heads chasing",
        "heraldic antelope head mirrored",
        "griffin's head mirrored",
        "three fish chasing",
        "three crows chasing",
        "three Viking swords chasing",
        "three heraldic antelopes chasing",
        "four seaxes chasing",
    ],
    "Chinese": [
        "Chinese symbol 9",
        "sky goddess",
        "rice spirit",
        "punishment demon",
        "dancing demon",
        "demon mask 2",
        "Chinese dragon",
        "Chinese symbol 3",
        "Chinese dragon 2",
        "dragon symbol",
        "Chinese symbol 1",
        "Chinese symbol 8",
        "Chinese symbol 4",
        "Chinese symbol 5",
        "Chinese symbol 7",
        "Chinese symbol 2",
        "quadrangle glyph",
        "Chinese symbol 6",
        "square circle glyph",
    ],
    "Conjoined": [
        "three dragon heads conjoined",
        "three escallops conjoined",
        "four sea-horses conjoined",
        "four Celtic dragons conjoined 2",
        // "four Celtic dragons conjoined",
        "three Celtic dragons conjoined",
        "four eagle's head conjoined",
        "three dragons conjoined",
        "three bat wings conjoined",
        "three armored legs conjoined",
        "three horses conjoined",
        "three hammers conjoined",
        "three axes conjoined",
        // "eight spear heads conjoined",
        "four Thor's hammers conjoined",
        "dexter arms conjoined",
    ],
    "Crowns": [
        "coronet",
        "crown",
        "panache",
        "chaplet of laurel",
        "coronet with ostrich feathers",
        "celestial crown",
    ],
    "Designs": [
        "circled plus",
        "Sumerian rose",
        "Viking ornament",
        "spider scarab 2",
        "Viking ring",
        "fleur-de-lis mirrored",
        "cinquefoil",
        "stylized bird",
        "Viking ring 2",
        "fleur-de-lis pointed",
        "fleur-de-lis",
        "trefoil",
        "quatrefoil",
        "annulet",
        "yin yang",
        "bowed square",
    ],
    "Egyptian": [
        "spider glyph",
        "sphynx passant gardant",
        "buzzard ritual",
        "egyptian boat 2",
        "Egyptian seal 2",
        "andro-sphynx",
        "Egyptian seal 1",
        "Egyptian cow",
        "Egyptian priest",
        "heiraco-sphynx",
        "scorpion seal",
        "sphynx",
        "Egyptian boat",
        "ibis seal",
        "horn seal",
        "pharoh",
        "neith",
        "Egyptian seal 4",
        "Egyptian seal 5",
        "ruler seal",
        "Egyptian seal 3",
        "lotus blossom",
        "sword seal",
    ],
    "Fish": [
        "fish hauriant",
        "escallop",
        "lobster",
        "carp",
        "dolphin and anchor",
        "salmon",
        "flying fish",
        "trout",
        "dolphin",
    ],
    "Japanese": [
        "Awoi-mon Mon of the House of Minamoto Tokugawa",
        "mon",
        "mikado chrysantumum",
        "kiri-mon",
        "Tomoye Mon of the House of Arina",
    ],
    "Knots": [
        "bouchon knot",
        "circle square knot",
        "diamond knot",
        "lacey",
        "ormond knot",
        "trinity knot",
    ],
    "Mayan": [
        "Mayan glyph 4",
        "God of Death",
        "Mayan glyph 9",
        "Mayan skull 2",
        "Mayan black captain",
        "Mayan glyph 10",
        "Mayan head 2",
        "Mayan head 1",
        "Mayan head 3",
        "War God",
        "Mayan glyph 1",
        "Mayan birdman",
        "Mayan head 7",
        "Mayan skull 1",
        "North Star god",
        "God of Harvest",
        "Mayan glyph 2",
        "Mayan glyph 8",
        "Mayan parrot",
        "Mayan head 4",
        "Mayan Sorceror God",
        "Mayan glyph 6",
        "drunk god",
        "mayan glyph 3",
        "Mayan glyph 5",
        "Mayan crab",
        "Mayan turtle 2",
        "Mayan scorpion",
        "Mayan helmet",
        "Mayan sun",
        "Mayan crocodile head",
        "Mayan lizard",
        "Mayan fish",
        "Mayan badge 2",
        "Mayan bird skull",
        "Mayan crocodile head 2",
        "Mayan snake head couped",
        "Mayan bird 2",
        "Mayan snake",
    ],
    "Middle Eastern": [
        "Babylonian horse",
        "sun-horse",
        "Persian griffon statant",
        "Persian god",
        "Babylonian hand",
        "Persian griffin",
        "Assyrian helmet",
        "Sumerian eagle",
        "Persian lion couped",
        "Babylonian eagle",
        "Babylonain bull",
        "Assyrian sheaf",
        "Persian knife 2",
        "Persian knife",
    ],
    "Mythical beasts": [
        "merman",
        "griffin statant",
        "harpy",
        "phoenix displayed",
        "dragon's head erased collared and chained",
        "cockatrice",
        "griffin rampant",
        "unicorn's head couped",
        "manticore",
        "opinicus",
        "wyvern",
        "heraldic tiger incensed",
        "theban",
        "tityrus sejant erect",
        "heraldic tiger statant",
        "pegasus rampant",
        "sea-dog rampant",
        "heraldic tiger passant",
        "mermaid",
        "dragon rampant",
        "heraldic dolphin hauriant",
        "sea-horse sejant erect",
        "heraldic dolphin anchored",
        "centaur",
        "unicorn rampant",
        "beast passant",
        "sea-horse rampant",
        "griffin's head erased",
        "heraldic antelope passant",
        "heraldic antelope rampant",
        "heraldic dolphin naiant",
        "unicorn passant",
        "dragon couchant",
        "heraldic antelope head couped",
        "pterodactyl",
        "jaguar mask",
    ],
    "Objects": [
        "cushion",
        "lymphad",
        "ship",
        // "skull", 
        "hawk's lure",
        "chess rook",
        "book",
        "horseshoe",
        "shinbones",
        "wheel",
        "water wheel",
        "fasces",
        "shack-bolt",
        "anchor",
        "buckle",
        // "lute",
        "compass",
        "hammer",
        "key",
        "crosier",
        "scales",
        "scythe",
        "hackle",
        "fork",
    ],
    "People": [
        "arm embowed",
        "angel",
        "man",
        "mounted knight",
        "savage's head",
        "Greek man with helmet",
        "angular face 1",
        "angular face 2",
        "two arms counter-embowed and interlaced",
        "cherub's head",
        "cubit arm habited",
        "hand in benediction",
        "dexter hand",
        "sinister hand",
        "cubit arm",
        "Phoenician coin",
    ],
    "Plants": [
        "ragged staff",
        "orange tree",
        "wheat sheaf",
        "pomegranate",
        "rose",
        "tree",
        "acorn",
        "rose slipped and leaved",
        "rose-en-soleil",
        "turnip",
        "laurel",
        "york rose",
        "trunk",
        "broom cod",
        "grapes",
        "thistle",
    ],
    "Primitive": [
        "primitive skull",
        "primitive fox",
        "primitive wildcat",
        "primitive horse",
        "primitive skull 3",
        "primitive elephant",
        "primitive symbol 3",
        "primitive claws",
        "primitive owl",
        "primitive hand",
        "primitive deer 2",
        "primitive symbol 4",
        "primitive fangs",
        "primitive symbol 5",
        "primitive warrior",
        "primitive rhino",
        "primitive buffalo 2",
        "primitive fish",
        "primitive elk",
        "primitive symbol 1",
        "primitive deer",
        "primitive symbol 2",
        "primitive hedgehog",
        "primitive harpoon",
        "primitive eagle",
    ],
    "Symbols": [
        "signs symbol",
        "clover symbol",
        "canoe symbol",
        "gear symbol",
        "incense burner symbol",
        "mushroom symbol",
        "trail marker symbol",
        "helmet symbol 2",
        "bird foot symbol",
        "water symbol",
        "helmet symbol",
        "easel symbol",
        "lantern symbol",
        "tail symbol",
        "arrow symbol",
        "Mycenean symbol 2",
        "pipe symbol",
        "tool symbol",
        "vase symbol",
        "bow symbol",
        "axe symbol",
        "blade symbol",
    ],
    "Weapons and armor": [
        "spartan sword",
        "roman helmet",
        "plumed helm",
        "chamfron",
        "gauntlet",
        "helmet 1",
        "greek helm",
        "broad arrow",
        "cubit arm in armour",
        "arm embowed in armour",
        "crossed swords",
        "scimitar",
        "khopesh",
        "seax",
        "halberd head",
        "sword",
        "sword 4",
        "sabre",
        "sword 3",
        "knife",
        "axe",
        "bill hook head",
        // "shortSword",
        "sabre 2",
        "warhammer",
        "sword 2",
    ],
}